export class AjaxOptions {
	url: string;
	data: any;
	contentType?= "application/json";
	success?: (data: any) => void;
	error?: (data: any) => void;
	method?= "post";
}


export class FormHelpers {


		public static postAjax(setOptions: AjaxOptions) {
			const options = { ...setOptions, ...new AjaxOptions() }; //merge options with default. 			
			const request = new XMLHttpRequest();
			request.open('POST', options.url, true);
			const isJson = options.contentType === 'application/json';
			request.onload = () => {
				const response = isJson ? JSON.parse(request.response) : request.response;
				if (request.status === 200) {
					options.success(response);
				} else {
					if (options.error !== null) {
						options.error(response);
					}
				}
			}

			request.onerror = () => {
				if (options.error !== null) {
					options.error(request);
				}
			}

			if (options.contentType && options.contentType !== "") {
				request.setRequestHeader('Content-Type', options.contentType);
			}
		

			if (options.contentType === 'application/json') {
				options.data = JSON.stringify(options.data);
			}

			request.send(options.data);
			return request;
		}

		public static getAjax(url: string, success: (response: any) => void, error: (response: any) => void) {
			const request = new XMLHttpRequest();
			request.open('GET', url, true);

			request.onload = () => {
				if (request.status === 200) {
					success(request.response);
				} else {
					error(request.response);
				}
			}

			request.onerror = () => {
				error(request);
			}


			request.send();
			return request;
		}

		public static validateForm(form: HTMLFormElement): boolean {

			const requiredFields = form.querySelectorAll('[required]');
			
			let isValid = true;
			requiredFields.forEach(field => {
				const inputValid = FormHelpers.setInputValidation(field as HTMLFormElement);

				if (isValid && !inputValid) {
					isValid = false; //if the form is currently valid and one input is invalid, switch the state and then mark the rest. 
				}
			});

			return isValid;
		}

		public static setInputValidation(input: HTMLFormElement) {
			const validationElement = input.parentElement.querySelector(".validation-message") as HTMLElement;

			if (!validationElement) {
				return true;
			}

			if (input.validity.valid) {
				validationElement.classList.add("field-validation-valid");
				validationElement.classList.remove("field-validation-error");
				validationElement.innerText = "";
				input.classList.remove("input-validation-error");
				return true;
			} else {
				validationElement.classList.add("field-validation-error");
				validationElement.classList.remove("field-validation-valid");
				validationElement.innerText = "Required";
				input.classList.add("input-validation-error");
				return false;
			}
		}

		public static addPhoneInputMask(input: HTMLInputElement) {
			input.addEventListener('input', (e) => {
				const element: HTMLInputElement = e.target as HTMLInputElement;
				const x = element.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
				element.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
			});
		}

}

